export default "__VITE_ASSET__d0a5e46e__"